import { Box, Typography, Container, Grid, Card, CardContent, CardMedia } from '@mui/material';
import { motion } from 'framer-motion';
import { PlayCircle } from '@mui/icons-material';

const InterviewHighlights = () => {
  const interviews = [
    {
      title: 'The Future of Business Communication',
      publication: 'Global Business Weekly',
      date: 'March 2025',
      image: '/images/interview1.jpg',
    },
    {
      title: 'Direct Access Leadership Model',
      publication: 'Executive Insights Magazine',
      date: 'February 2025',
      image: '/images/interview2.jpg',
    },
    {
      title: 'Building Global Partnerships',
      publication: 'International Trade Journal',
      date: 'January 2025',
      image: '/images/interview3.jpg',
    },
  ];

  return (
    <Box sx={{ py: 15, background: '#111' }}>
      <Container maxWidth="lg">
        <Typography
          variant="subtitle1"
          sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
        >
          FEATURED INTERVIEWS
        </Typography>

        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 8,
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          In The Media
        </Typography>

        <Grid container spacing={4}>
          {interviews.map((interview, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    background: '#0B0B0B',
                    border: '1px solid rgba(200,169,107,0.2)',
                    transition: 'all 0.3s',
                    '&:hover': {
                      borderColor: '#C8A96B',
                      transform: 'translateY(-5px)',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="180"
                    image={interview.image}
                    alt={interview.title}
                    sx={{ objectFit: 'cover' }}
                  />
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <PlayCircle sx={{ color: '#C8A96B', fontSize: 20 }} />
                      <Typography variant="caption" sx={{ color: '#C8A96B' }}>
                        Watch Interview
                      </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ mb: 1, fontSize: '1.1rem' }}>
                      {interview.title}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#999', display: 'block', mb: 1 }}>
                      {interview.publication}
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#666' }}>
                      {interview.date}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default InterviewHighlights;